import { useRef } from 'react'
import type { StepLoadedHook } from '../../../types/lifecycle-hooks'

export const useStepLifecycle = (): { handleStepLoaded: StepLoadedHook } => {
  // Needed to skip side effects on first step load
  const isInitialMount = useRef(true)

  const handleStepLoaded: StepLoadedHook = (_stepIndex: number, _stepName: string): void => {
    if (isInitialMount.current) {
      isInitialMount.current = false
      return
    }

    window.scrollTo({ top: 0, behavior: 'smooth' })

    // NOTE: This should serve as an extension point for any post-render
    // side effects for questionnaire steps
  }

  return { handleStepLoaded }
}
